export default status => {
  if (status === 'FIXED') {
    return 'Fixed';
  } if (status === 'VARIABLE') {
    return 'Variable';
  } return 'Per Unit';
};
